import { Dispatch } from "react";
import { POSTAPI, DELETEAPI } from "../../API/Api";
import {
  DELETE_FILE_FAIL,
  DELETE_FILE_REQUEST,
  DELETE_FILE_SUCCESS,
  GET_PRESIGNED_URL_FAIL,
  GET_PRESIGNED_URL_REQUEST,
  GET_PRESIGNED_URL_SUCCESS,
  UPLOAD_FILE_FAIL,
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_SUCCESS,
} from "../../Constants/S3UploadConstants";

export const GetPresignedUrlAction =
  (params: string, payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_PRESIGNED_URL_REQUEST });
      const data = await POSTAPI(params, payload, false);
      if (data && data.status === true) {
        dispatch({
          type: GET_PRESIGNED_URL_SUCCESS,
          data: data,
        });
        return data;
      } else {
        dispatch({
          type: GET_PRESIGNED_URL_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: GET_PRESIGNED_URL_FAIL,
        data: null,
      });
      return null;
    }
  };

export const UploadFileAction =
  (params: string, payload: any, toastStatus: boolean = true) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPLOAD_FILE_REQUEST });

      const data = await POSTAPI(params, payload, toastStatus);

      if (data && data.status === true) {
        dispatch({
          type: UPLOAD_FILE_SUCCESS,
          data: data.data,
        });
        return data;
      } else {
        dispatch({
          type: UPLOAD_FILE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: UPLOAD_FILE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const DeleteFileAction =
  (params: string, toastStatus: boolean = true) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: DELETE_FILE_REQUEST });

      const data = await DELETEAPI(params, toastStatus);

      if (data && data.status === true) {
        dispatch({
          type: DELETE_FILE_SUCCESS,
          data: data.data,
        });
        return data;
      } else {
        dispatch({
          type: DELETE_FILE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: DELETE_FILE_FAIL,
        data: null,
      });
      return null;
    }
  };
